import { __awaiter, __generator } from "tslib";
import { createClient } from './serviceProxy';
var useDDSClient = function (_a) {
    var apikey = _a.apikey;
    var client = createClient({ apikey: apikey });
    var ENDPOINT_PATH_TELECOMMUNICATION = "/dds/getData/allValueParameter_byLabel?parameter_label=Losing%20telecommunications%20provider";
    var telkoPreProvider = [
        { value: 'Custom', label: ' Nicht in Liste enthalten' },
        { value: 'DEU.1UND1', label: '1 & 1, Tiscali, freenet' },
        { value: 'DEU.BORNET', label: 'BORnet GmbH' },
        { value: 'DEU.BRANDL', label: 'Brandl Services GmbH' },
        { value: 'DEU.D012', label: 'BT Ignite' },
        { value: 'DEU.BUDI', label: 'Buchholz Digital' },
        { value: 'DEU.COLTDE', label: 'COLT TELECOM' },
        { value: 'DEU.COMIN', label: 'COM-IN' },
        { value: 'DEU.CONG', label: 'Congstar (T-Online)' },
        { value: 'DEU.DACOR', label: 'Dacor GmbH' },
        { value: 'DEU.DCC', label: 'DCC GmbH' },
        { value: 'DEU.DETEST', label: 'Deu.Tel.Standard' },
        { value: 'DEU.DGH', label: 'Deutsche Glasfaser Home GmbH' },
        { value: 'DEU.DGW', label: 'Deutsche Glasfaser Wholesale GmbH' },
        { value: 'DEU.DTAG', label: 'Deutsche Telekom, T-Mobile' },
        { value: 'DEU.DNSNET', label: 'DNS:NET Internet Service GmbH' },
        { value: 'DEU.DOKOM', label: 'DOKOM' },
        { value: 'DEU.DUSNET', label: 'dus.net GmbH' },
        { value: 'DEU.ENET', label: 'E.Net GmbH und Co.KG' },
        { value: 'DEU.EASYBL', label: 'easybell GmbH' },
        { value: 'DEU.ECOTEL', label: 'Ecotel' },
        { value: 'DEU.EWG', label: 'Elektrizitätswerk Goldbach-Hösbach' },
        { value: 'DEU.ELINE', label: 'encoLine GmbH, Thüringer Netkom' },
        { value: 'DEU.ETEL', label: 'envia.tel, Chemnitz' },
        { value: 'DEU.DE1EPC', label: 'epcan GmbH' },
        { value: 'DEU.EQUADA', label: 'Equada GmbH' },
        { value: 'DEU.EWE', label: 'EWETel' },
        { value: 'DEU.FLINK', label: 'FLINK GmbH' },
        { value: 'DEU.GWHTEL', label: 'GWHtel GmbH und Co.KG' },
        { value: 'DEU.HMN', label: 'HEAG MediaNet, Darmstadt' },
        { value: 'DEU.HELI01', label: 'HeLi NET GmbH' },
        { value: 'DEU.HERZO', label: 'HerzoMedia' },
        { value: 'DEU.HFO', label: 'HFO Telecom' },
        { value: 'DEU.HTP', label: 'HTP, Hannover' },
        { value: 'DEU.INEXIO', label: 'inexio IT und TK KGaA' },
        { value: 'DEU.RWEFN', label: 'innogy TelNet GmbH (RWE)' },
        { value: 'DEU.INOPLA', label: 'inopla GmbH' },
        { value: 'DEU.KBW', label: 'Kabel BW' },
        { value: 'DEU.KDVS', label: 'Kabel Deutschland Vertrieb' },
        { value: 'DEU.KNET', label: 'K-Net Telekommunikation GmbH' },
        { value: 'DEU.KOMRO', label: 'komro GmbH' },
        { value: 'DEU.D115', label: 'MDCC, Magdeburg' },
        { value: 'DEU.MNET', label: 'M-net, AugustaKom, NEFKom' },
        { value: 'DEU.MD8000', label: 'mobilcom-debitel GmbH' },
        { value: 'DEU.NETAC', label: 'NETAACHEN GmbH' },
        { value: 'DEU.NETCO', label: 'NETCOLOGNE' },
        { value: 'DEU.NCKS', label: 'Netcom, Kassel' },
        { value: 'DEU.SWB', label: 'NordCom, Bremen' },
        { value: 'DEU.D061', label: 'o2 Mobile / o2 Homezone (Festnetznummer)' },
        { value: 'DEU.ORNET', label: 'OR Network GmbH' },
        { value: 'DEU.OSNATL', label: 'Osnatel, Osnabrück' },
        { value: 'DEU.PICODE', label: 'pinnau.com GmbH und Co.KG' },
        { value: 'DEU.FLTC', label: 'Pyur (Tele Columbus/HL-Komm)' },
        { value: 'DEU.QSC', label: 'QSC, Broadnet Mediascape, Ventelo' },
        { value: 'DEU.QUIX', label: 'Quix Breitband GmbH' },
        { value: 'DEU.REVTIX', label: 'Reventix GmbH' },
        { value: 'DEU.RKOM', label: 'R-KOM, Regensburg' },
        { value: 'DEU.SG', label: 'Sipgate Wireless, netzquadrat' },
        { value: 'DEU.SNBG', label: 'Stadtnetze Barmstedt GmbH' },
        { value: 'DEU.SWATEL', label: 'Stadtwerke Ahrensburg GmbH' },
        { value: 'DEU.BITEL', label: 'Stadtwerke Bielefeld GmbH' },
        { value: 'DEU.SWENG', label: 'Stadtwerke Engen' },
        { value: 'DEU.SWEUDI', label: 'Stadtwerke Eutin GmbH' },
        { value: 'DEU.SWFL', label: 'Stadtwerke Flensburg GmbH' },
        { value: 'DEU.SWKN', label: 'Stadtwerke Konstanz' },
        { value: 'DEU.SWNNET', label: 'Stadtwerke Neumünster GmbH' },
        { value: 'DEU.DEUNOR', label: 'Stadtwerke Nortel' },
        { value: 'DEU.STERN', label: 'Stern Kom GmbH' },
        { value: 'DEU.SIS', label: 'Stiegeler Internet Services GmbH Co.KG' },
        { value: 'DEU.TRILAN', label: 'SWT trilan GmbH ' },
        { value: 'DEU.SYMBOX', label: 'symbox' },
        { value: 'DEU.TQUICK', label: 'tel.quick GmbH und Co. KG' },
        { value: 'DEU.TEL2DE', label: 'Tele 2, Düsseldorf' },
        { value: 'DEU.TDGMBH', label: 'TeleData GmbH' },
        { value: 'DEU.TELSA1', label: 'Telsakom GmbH' },
        { value: 'DEU.TNG', label: 'TNG Stadtnetz' },
        { value: 'DEU.UMNRW', label: 'Unitymedia GmbH' },
        { value: 'DEU.UMHESS', label: 'Unitymedia Hessen GmbH & Co.KG' },
        { value: 'DEU.VSM', label: 'Vereinigte Stadtwerke Media GmbH' },
        { value: 'DEU.MCI', label: 'Verizon Deutschland GmbH' },
        { value: 'DEU.VTEL', label: 'Versatel, TROPOLYS, CNE, KielNet' },
        { value: 'DEU.VBBGFA', label: 'Versorgungsbetriebe Bordesholm GmbH' },
        { value: 'DEU.VFDE', label: 'Vodafone, ISIS, WüCom' },
        { value: 'DEU.VOICEW', label: 'Voiceworks' },
        { value: 'DEU.VSENET', label: 'VSE Net, Saarbrücken' },
        { value: 'DEU.WTNET', label: 'wilhelm.tel' },
        { value: 'DEU.WTHAM', label: 'willy.tel GmbH' },
        { value: 'DEU.WISOTL', label: 'Wisotel' },
        { value: 'DEU.WOBCOM', label: 'WOBCOM GmbH, Wolfsburg' },
        { value: 'DEU.ZDGMBH', label: 'zollernalb-data GmbH' }
    ];
    var getTelecommunicationsList = function () { return __awaiter(void 0, void 0, Promise, function () {
        var response, telecommunicationsListMap, e_1, ddsRes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    response = null;
                    telecommunicationsListMap = new Map();
                    telecommunicationsListMap.set(1, telkoPreProvider);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.get(ENDPOINT_PATH_TELECOMMUNICATION)];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1.message);
                    return [3 /*break*/, 4];
                case 4:
                    if (!response || !response.data)
                        return [2 /*return*/, telecommunicationsListMap];
                    console.log('tellist', response === null || response === void 0 ? void 0 : response.data.data.data.data);
                    ddsRes = response === null || response === void 0 ? void 0 : response.data.data.data;
                    console.log('resp', ddsRes);
                    // Default aus lokaler Liste
                    ddsRes.data.forEach(function (dynamicData) {
                        var keyValue = dynamicData.parameterValues.dynamicData.value.map(function (data) { return ({
                            label: data.losingProvider,
                            value: data.carrierCode || data.portingIdentifier[0]
                        }); });
                        keyValue.push({ value: 'Custom', label: ' Nicht in Liste enthalten' });
                        telecommunicationsListMap.set(dynamicData.parameterValues.dynamicData.sourceId, keyValue.sort(function (a, b) { return a.label.localeCompare(b.label); }));
                    });
                    console.log('telecommunicationsListMap', telecommunicationsListMap);
                    return [2 /*return*/, telecommunicationsListMap];
            }
        });
    }); };
    return { getTelecommunicationsList: getTelecommunicationsList };
};
export default useDDSClient;
